import { HVH_COLORS } from "../../config/palette";

export const ALLOWED_FILE_TYPES = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];

export const documentFrontTitleMessage = "Add an image of the FRONT";
export const documentBackTitleMessage = "Add an image of the BACK";
export const documentUploadErrorText = "The upload did not meet the acceptable file size or format. Please try again.";

export const dropZoneAttributes = {
  backgroundColor: HVH_COLORS.PRIMARY_05,
  borderColor: HVH_COLORS.PRIMARY_70,
  borderWidth: "2px",
  fontSize: "15px",
  borderRadius: "0px",
  minHeight: "0px",
  padding: "5px",
};

export const inputAttributes = {
  color: HVH_COLORS.PRIMARY_70,
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const previewAttributes = {
  backgroundColor: "",
  innerHeight: "50px !important",
  outerHeight: "50px !important",
  outerWidth: "30px",
  innerWidth: "30px",
};
